import { For, createUniqueId } from "solid-js";
import { locales, type Locale } from "../i18n/dictionary.ts";
import { useI18n } from "../i18n/provider.tsx";
import styles from "./LanguagePicker.module.scss";

/** Locale switch; the choice is persisted by the i18n provider. */
export const LanguagePicker = () => {
  const i18n = useI18n();
  const controlId = createUniqueId();

  return (
    <div class={styles.wrapper}>
      <label for={controlId}>{i18n.t().app.language}</label>
      <select
        id={controlId}
        class={styles.select}
        value={i18n.locale()}
        onChange={(event) => i18n.setLocale(event.currentTarget.value as Locale)}
      >
        <For each={locales}>
          {(locale) => <option value={locale}>{i18n.t().app.localeName[locale]}</option>}
        </For>
      </select>
    </div>
  );
};
